// extracted by mini-css-extract-plugin
export default {"stickerWrap":"Sticker_stickerWrap__6gdAL"};